import script from "./OrderNotificationCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderNotificationCard.vue?vue&type=script&lang=ts&setup=true"

import "./OrderNotificationCard.vue?vue&type=style&index=0&id=81efb6ec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81efb6ec"]])

export default __exports__